import { createElement } from 'react';

interface EditableProps {
  isEditable: boolean;
  value: string;
  onChange: (val: string) => void;
  as?: string;
  className?: string;
  multiline?: boolean;
}

export default function Editable({ isEditable, value, onChange, as = 'div', className = '', multiline = false }: EditableProps) {
  if (!isEditable) {
    const props: { className: string; dangerouslySetInnerHTML?: { __html: string } } = {
      className: `${className} whitespace-pre-wrap`,
      dangerouslySetInnerHTML: { __html: value || '' },
    };
    return createElement(as, props);
  }

  const editClasses = `${className} bg-white/90 border-2 border-dashed border-[#c69c6d] outline-none focus:bg-white focus:ring-4 focus:ring-[#c69c6d]/30 focus:border-[#125b60] rounded-xl p-2 transition-all block w-full shadow-lg text-slate-800 font-sans font-normal text-base leading-normal`;

  if (multiline) {
    return (
      <textarea
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        className={editClasses}
        rows={value && value.length > 60 ? 4 : 2}
        onClick={(e) => e.preventDefault()}
      />
    );
  }

  return (
    <input
      type="text"
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      className={editClasses}
      onClick={(e) => e.preventDefault()}
    />
  );
}